module.exports = __webpack_public_path__ + "assets/engine-start-icon.f7c91d74.svg";